import { render, staticRenderFns } from "./MoleculeBuildingLabel.vue?vue&type=template&id=cf8e8c7c&"
import script from "./MoleculeBuildingLabel.vue?vue&type=script&lang=js&"
export * from "./MoleculeBuildingLabel.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeBuildingLabel.vue?vue&type=style&index=0&id=cf8e8c7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeBuildingLabel.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FMoleculeBuildingLabel.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsAtomLoader: require('/app/components/atoms/AtomLoader.vue').default})
